/**
 * Reads canvas metrics from a Chart.js chart instance using const bindings (S3504).
 */
export function getChartCanvasMetrics(chart) {
  const { width } = chart.chart;
  const { height } = chart.chart;
  const { ctx } = chart.chart;
  return { width, height, ctx };
}
